/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 3;
`;

export const Body = styled.div`
  height: 100px;
  width: 100px;
  border-radius: 10px;
  display: flex;
  padding-left: 10px;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  opacity: 1;
`;
